import { render, staticRenderFns } from "./ManagersSettings.vue?vue&type=template&id=56949f0e&"
import script from "./ManagersSettings.vue?vue&type=script&lang=ts&"
export * from "./ManagersSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ManagersSettings.vue?vue&type=style&index=0&id=56949f0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports